import React from "react";
import { EnvelopeSimple, UserCircleCheck, UserCircleMinus, UserPlus } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const META = {
  active: { label: "Has login", cls: "border-emerald-700 bg-emerald-100 text-emerald-900", Icon: UserCircleCheck, tip: "Has signed in before" },
  invited: { label: "Invited · not signed in yet", cls: "border-amber-700 bg-amber-100 text-amber-900", Icon: EnvelopeSimple, tip: "Has a login but hasn't signed in yet" },
  none: { label: "No login yet", cls: "border-red-700 bg-red-50 text-red-800", Icon: UserCircleMinus, tip: "Invite them so they can open their dashboard" },
};
const BASE = "inline-flex items-center gap-1 border px-1 text-[9px] uppercase tracking-widest";

function useCanInvite() {
  const { user } = useAuth();
  return user?.org_type === "internal" && (user.role === "super_admin" || (user.permissions || []).includes("manage_routing"));
}

// Buyer login status: signed in before, invited but never signed in, or no login. "No login yet" opens the invite box.
export function LoginStatusBadge({ login, testId, onInvite }) {
  const canInvite = useCanInvite();
  if (!login) return null;
  const m = META[login.status] || META.none;
  if (login.status === "none" && onInvite && canInvite) {
    return (
      <button type="button" onClick={onInvite} title="Invite a login for this buyer" data-testid={testId} data-status="none"
              className={`${BASE} ${m.cls} transition-colors duration-100 hover:bg-red-700 hover:text-white`}>
        <m.Icon size={10} weight="bold" /> {m.label} <span className="inline-flex items-center gap-0.5 underline"><UserPlus size={10} weight="bold" />Invite</span>
      </button>
    );
  }
  const who = login.emails?.length ? ` · ${login.emails.join(", ")}` : "";
  return (
    <span className={`${BASE} ${m.cls}`} title={`${m.tip}${who}`} data-testid={testId} data-status={login.status}>
      <m.Icon size={10} weight="bold" /> {m.label}
    </span>
  );
}
